import { motion, useScroll, useTransform } from "motion/react";
import { useRef } from "react";

export function ParallaxText({
  children,
  className = "",
  offset = 50,
}) {
  const ref = useRef(null);
  // const { scrollYProgress } = useScroll({
  //   target: ref,
  //   offset: ["start end", "end start"],
  // });

  // const y = useTransform(scrollYProgress, [0, 1], [offset, -offset]);

  return (
    <motion.div ref={ref}  className={className}>
      {children}
    </motion.div>
  );
}
